import { Flex } from '@chakra-ui/react';
import Header from '@components/typography/Header';
import Image from 'next/image';

const CardHeading = ({ title, src, alt }) => {
  return (
    <Flex mb={2} alignItems="center" gap={4}>
      <Image src={src} height={30} width={30} alt={alt} />
      <Header as="h4" display="inline-block">
        {title}
      </Header>
    </Flex>
  );
};

export default CardHeading;
